import { Container } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { BeforeAfterComparison } from "../components/BeforeAfterComparison";

export const Route = createFileRoute("/comparison")({
  component: ComparisonPage,
});

function ComparisonPage() {
  return (
    <Container size="lg" py="xl">
      <BeforeAfterComparison />
    </Container>
  );
}
